module.exports = __webpack_public_path__ + "static/media/delete.b71c4f40.svg";